module.exports = __webpack_public_path__ + "media/images/emblems/Bowil-coat_of_arms-1441cc2abb1364dd408c878950953084.svg";